<template>
    <div id="sidebar" :class="{ open: menu.isOpen || menu.hoverActive }">
        <div class="content">
            <div
                class="menu-list"
                v-if="permissions.length || isAdmin"
                :key="'menu-' + forceRenderCount"
                ref="scrollRef"
                @mouseenter="mouseEnterStart"
                @mouseleave="mouseLeaveStart"
            >
                <template v-for="item in allowedRoutes()">
                    <a-tooltip
                        :title="item.title"
                        placement="right"
                        :key="item.key"
                        :overlayClassName="menu.isOpen || menu.hoverActive ? ' hiddenToolTip' : ''"
                        @click="closeMenu"
                    >
                        <router-link :to="item.path" class="menu-list-item">
                            <div class="menu-list-item-icon">
                                <div v-if="item.isNew" class="new-tag">NEW</div>
                                <a-icon
                                    :type="item.antIcon"
                                    v-if="item.antIcon"
                                    style="font-size: 20px"
                                    :style="{ color: bugExist ? 'red !important' : '#9ba2b6 !important' }"
                                />
                                <component v-bind:is="item.icon" class="myIcon" v-else />
                            </div>
                            <div class="menu-list-item-title">{{ item.title }}</div>
                        </router-link>
                    </a-tooltip>
                </template>
            </div>
            <div class="dropdown-control" @click="clickItem">
                <div class="information-text">{{ $t("message.showHide")}}</div>
                <div>
                    <div class="material-icons">
                        {{ menu.isOpen || menu.hoverActive ? "chevron_left" : "chevron_right" }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import menu from "../utils/menu";
import Comments from "./svg/Comment";
import History from "./svg/History";
import Visitor from "./svg/Visitor";
import Masks from "./svg/Masks";
import Users from "./svg/User";
import Trigger from "./svg/Trigger";
import Integrations from "./svg/Integrations";
import UserSlash from "./svg/UserSlash";
import ClipboardList from "./svg/ClipboardList";
import BoxOpen from "./svg/BoxOpen";
import HandPaper from "./svg/HandPaper";
import Ban from "./svg/Ban";
import Arrows from "./svg/Arrows";
import Cogs from "./svg/Cogs";
import Bug from "./svg/Bug";
import WindowOpen from "./svg/WindowOpen";
import Calendar from "./svg/Calendar";
import ClusterDashboard from "./svg/ClusterDashboard";
import Site from "./svg/Site";
import { log2 } from "../utils/log2";
import OfflineSupport from "./svg/OfflineSupport";
import DetailReports from "./svg/DetailReports";
import Catalog from "./svg/Catalog";
import Chatbot from "./svg/Chatbot";
import Ticket from "./svg/Ticket";
import Integration from "./svg/Integration";
import CreditCard from "./svg/CreditCard";
import { getPersistenceData } from "../utils/persistenceStorage";
import { SELF_SERVICE_DOMAIN } from "../utils/utils";
import Apps from "./svg/Apps";
import Tags from "./svg/Tags";
import systemPubSub from "../utils/systemPubSub";
import { filter } from "rxjs/operators";
import InstagramIcon from "./svg/InstagramIcon";
import Coupon from "./svg/Coupon";
import AdminReports from "./svg/AdminReports.vue";

const log = log2("Sidebar");
export default {
    name: "Sidebar",
    components: {
        Coupon,
        InstagramIcon,
        Integration,
        Apps,
        Comments,
        Chatbot,
        History,
        Masks,
        Users,
        Visitor,
        UserSlash,
        ClipboardList,
        BoxOpen,
        HandPaper,
        Ban,
        Cogs,
        Bug,
        WindowOpen,
        Calendar,
        OfflineSupport,
        DetailReports,
        Catalog,
        ClusterDashboard,
        Site,
        Ticket,
        CreditCard,
        Arrows,
        Trigger,
        Tags,
        Integrations,
        AdminReports,
    },
    data() {
        return {
            forceRenderCount: 0,
            timerId: null,
            timerId2: null,
            debugMode: SELF_SERVICE_DOMAIN === location.hostname,
            hoverTimerId: null,
            unSubs: [],
        };
    },

    mounted() {
        const firstItem = this.allowedRoutes()[0];
        if (firstItem && this.$route.path === "/denied") {
            this.$router.push(firstItem.path);
        }
        this.timerId = setInterval(() => {
            if (!this.permissions.length && this.isLoggedIn) {
                this.getPermissions({ perPage: 500, page: 1 });
            }
            if (this.permissions.length && this.timerId) {
                clearInterval(this.timerId);
            }
        }, 5000);
        if (this.ticketViewPermissionExists) {
            this.fetchWaitingTickets({
                page: 1,
                perPage: !isNaN(getPersistenceData("ticket-page-size") || "undefined")
                    ? parseInt(getPersistenceData("ticket-page-size"))
                    : 10,
                tag: "all",
            });
            const newTicketSub = systemPubSub.stream.pipe(filter((x) => x.type === "ticket_message")).subscribe((x) => {
                this.fetchWaitingTickets({
                    page: 1,
                    perPage: !isNaN(getPersistenceData("ticket-page-size") || "undefined")
                        ? parseInt(getPersistenceData("ticket-page-size"))
                        : 10,
                    tag: "all",
                });
            });
            this.unSubs.push(() => newTicketSub.unsubscribe());
        }
    },
    computed: {
        ...mapState({
            menu: (state) => state.layout.menu,
            user: (state) => state.auth.user,
            bugExist: (state) => state.auth.bugExist,
            adminUser: (state) => state.auth.adminUser,
            isAdmin: (state) => state.auth.adminUser != null,
            permissions: (state) => state.permission.permissions,
            ticketViewPermissionExists: (state) => {
                const isRoot = _.get(state.auth.user, "role.isRoot");
                return (
                    isRoot ||
                    !!(_.get(state.auth.user, "role.permissions") || []).find(
                        (x) => x.name === "offlineSupportRequest.get"
                    )
                );
            },
        }),
        ...mapGetters({
            isLoggedIn: "auth/isLoggedIn",
            getWaitingTickets: "ticket/getWaitingTickets",
        }),
        isUserRoutes() {
            const userRoutes = ["/users", "/roles", "banned-visitors", "departments"];
            return userRoutes.includes(this.$route.path);
        },
        isContentRoutes() {
            const contentRoutes = ["/templates", "/system-messages", "/catalog,", "/forbidden-inputs,", "/tags,"];
            return contentRoutes.includes(this.$route.path);
        },
    },
    methods: {
        ...mapActions({
            toggleMenu: "layout/toggleMenu",
            toggleHoverMenu: "layout/toggleHoverMenu",
            getPermissions: "permission/getPermissions",
            fetchWaitingTickets: "ticket/fetchWaitingTickets",
        }),
        mouseEnterStart() {
            this.hoverTimerId = setTimeout(() => {
                this.toggleHoverMenu(true);
            }, 750);
        },
        mouseLeaveStart() {
            if (this.hoverTimerId) clearTimeout(this.hoverTimerId);
            this.toggleHoverMenu(false);
        },
        clickItem() {
            this.toggleMenu();
        },
        closeMenu(item) {
            this.toggleHoverMenu(false);
            this.toggleMenu(false);
        },
        allowedRoutes() {
            let items = this.getSideBarItems();

            if (this.adminUser) {
                items = items.filter((item) => {
                    if (this.adminUser.isFullAccess) return true;
                    else if (item.superAdminPageKey)
                        return (this.adminUser.approvedPages || []).map((x) => x.page).includes(item.superAdminPageKey);
                    else {
                        return true;
                    }
                });
                return items;
            }
            if (this.user.role.isRoot) {
                return items.filter((c) => !c.isAdmin);
            }
            try {
                log("perms", {
                    items: items.map((x) => x.permission),
                    userRoles: this.user.role.permissions.map((x) => x.name),
                });
                return items.filter(
                    (menuItem) =>
                        !menuItem.isAdmin &&
                        !!this.user.role.permissions.find((userPermission) => {
                            if (!menuItem.permission) return true;
                            if (Array.isArray(menuItem.permission)) {
                                if (menuItem.permission.includes(userPermission.name)) {
                                    return true;
                                }
                            }
                            if (userPermission !== null && userPermission.name === menuItem.permission) {
                                return true;
                            }
                        })
                );
            } catch (e) {
                console.error(
                    "Some permission with a name could not found! Compare menu items and stored permission keys.",
                    e
                );
            }
        },
        getSideBarItems() {
            return menu(this).filter((x) => x.enabled);
        },
    },
    beforeDestroy() {
        this.unSubs.forEach((sub) => sub());
        if (this.timerId) clearInterval(this.timerId);
        if (this.timerId2) clearInterval(this.timerId2);
    },
    watch: {
        $route(to, from) {
            const FirstItem = this.allowedRoutes()[0];
            if (this.$route.path === "/denied" && !this.isUserRoutes && !this.isContentRoutes) {
                this.$router.push(FirstItem.path);
            }
        },
    },
};
</script>
<style lang="scss">
.hiddenToolTip {
    opacity: 0 !important;
    display: none !important;
}
</style>
<style lang="scss" scoped>
.menu-list-item-icon {
    position: relative;

    .new-tag {
        position: absolute;
        background-color: #fe6244;
        color: white;
        padding: 2px 5px;
        font-size: 5px;
        height: 16px;
        border-radius: 50%;
        width: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        right: -7px;
        top: -8px;
        clip-path: polygon(
            10% 0%,
            20% 10%,
            30% 0%,
            40% 10%,
            50% 0%,
            60% 10%,
            70% 0%,
            80% 10%,
            90% 0%,
            100% 10%,
            100% 20%,
            90% 30%,
            100% 40%,
            90% 50%,
            100% 60%,
            90% 70%,
            100% 80%,
            90% 90%,
            100% 100%,
            90% 100%,
            80% 90%,
            70% 100%,
            60% 90%,
            50% 100%,
            40% 90%,
            30% 100%,
            20% 90%,
            10% 100%,
            0% 90%,
            0% 80%,
            10% 70%,
            0% 60%,
            10% 50%,
            0% 40%,
            10% 30%,
            0% 20%,
            10% 10%,
            0% 0%
        );
        animation: grow-shrink 2s infinite;
    }
}

@keyframes grow-shrink {
    0%,
    100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.2);
    }
}
#sidebar {
    //overflow: hidden;
}

#sidebar > ul {
    cursor: pointer;
}

#sidebar > ul > li > ul {
    margin-top: 9px;

    li {
        margin: 4px 0 6px 6px;
    }
}

.myIcon {
    width: 22px;
    height: 22px;
}

.new-theme {
    #sidebar {
        &.open header {
            padding: 0 30px;
            justify-content: space-between;
        }

        header {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0;
            height: 65px;
            cursor: pointer;

            #arrow-icon {
                transition: all 0.3s;
                transform: rotateY(180deg);

                &.open {
                    transform: rotateY(0deg);
                }
            }

            h1 {
                font-family: "Poppins";
                font-weight: bold;
                font-size: 18px;
                color: #ffffff;
                margin: 0;
                user-select: none;
            }
        }

        ul li a {
            color: #a2a3b7;
            font-family: "Poppins";
            font-size: 13px;

            &.router-link-exact-active.router-link-active {
                color: #ffffff;
            }
        }

        .instagram-icon {
            svg {
                width: 26px !important;
                height: 26px !important;
                border-radius: 4px !important;
                background: radial-gradient(
                    circle at 30% 107%,
                    #fdf497 0%,
                    #fdf497 5%,
                    #fd5949 45%,
                    #d6249f 60%,
                    #285aeb 90%
                ) !important;
            }
        }
    }
}
</style>
